import { capitalize } from 'lodash'

import { Source } from '../../models/Source'
import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { Checkbox } from '../common/fields/Checkbox'

type Props = {
    isOpen: boolean
    onClose: () => void
    sources: Source[]
    onSelect: (source: Source) => void
    onAddNew: () => void
    selectedSourceID?: string | null
}

export const SourcesModal = ({
    isOpen,
    onClose,
    sources,
    onSelect,
    onAddNew,
    selectedSourceID,
}: Props) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Payment methods"
            footer={
                <Button onClick={onAddNew} intent="secondary">
                    Add a card
                </Button>
            }
        >
            <div className="flex flex-col items-stretch justify-start gap-y-4">
                {sources.map((source) => (
                    <button
                        key={source.id}
                        className="flex items-center justify-start gap-x-4 overflow-x-hidden rounded-lg border border-gray-300 p-4 text-left hover:bg-black/4"
                        onClick={() => onSelect(source)}
                    >
                        <div className="shrink-0">{source.icon}</div>

                        <div className="min-w-0 shrink grow">
                            <div className="truncate font-bold">{source.displayTitle}</div>
                            <div className="truncate text-gray-600">{source.displayBankName}</div>
                        </div>

                        <div className="shrink-0">
                            <div className="font-bold">{source.displayExpiresString}</div>
                            <div className="text-right text-gray-600">
                                {capitalize(source.type)}
                            </div>
                        </div>

                        {selectedSourceID !== undefined && (
                            <Checkbox style="radio" isChecked={selectedSourceID === source.id} />
                        )}
                    </button>
                ))}
            </div>
        </Modal>
    )
}
